import type { Set } from '@gonfalon/immutable-shim/immutableShim';

import { getTagsClause } from './getTagsClause';

export function makeResourceSpec(
  projectKey: string,
  envKey: string,
  resourceKind: string,
  resourceKey: string,
  tags: ArrayLike<string> | Set<string>,
) {
  return `proj/${projectKey}:env/${envKey}:${resourceKind}/${resourceKey}${getTagsClause(tags)}`;
}
